import { Container } from '@dma/ui';
import { ContactForm } from './ContactForm';
import { ContactInfo } from './ContactInfo';
import { contactInfoContent } from '../../../content/company-info.content';
import { useDocumentHead } from '../../../app/seo/useDocumentHead';
import { staticSeo } from '../../../app/seo/static-seo.content';
import './ContactPage.css';

export function ContactPage() {
  useDocumentHead(staticSeo.contact);

  return (
    <Container>
      <section className="dma-contact-page">
        <div className="dma-contact-page__form">
          <h1>تماس با ما</h1>
          <ContactForm />
        </div>
        <div className="dma-contact-page__info">
          <ContactInfo content={contactInfoContent} />
        </div>
      </section>
    </Container>
  );
}
